// extracted by mini-css-extract-plugin
export default {"title":"NewProjectPopup_title__Uq+Dj","iconEdit":"NewProjectPopup_iconEdit__9LcOI","explanation":"NewProjectPopup_explanation__IwR4i"};